import { initializeApp, FirebaseApp } from 'firebase/app'
import { getAuth, connectAuthEmulator, Auth } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator, Firestore } from 'firebase/firestore'
import { getStorage, connectStorageEmulator, FirebaseStorage } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator, Functions } from 'firebase/functions'

// Firebase configuration - using environment variables for security
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
}

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig)

// Initialize Firebase services
export const auth: Auth = getAuth(app)
export const db: Firestore = getFirestore(app)
export const storage: FirebaseStorage = getStorage(app)
export const functions: Functions = getFunctions(app)

// Helper functions for hooks
export function getFirebaseDb(): Firestore {
    return db
}

export function getFirebaseAuth(): Auth {
    return auth
}

export function getFirebaseStorage(): FirebaseStorage {
    return storage
}

export function getFirebaseFunctions(): Functions {
    return functions
}

// Track emulator connection
let emulatorsConnected = false

// Connect to emulators in development
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true' && !emulatorsConnected) {
    console.log('🔧 Development mode: Connecting to Firebase emulators...')

    try {
        // if (!auth.config.emulator) {
        connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
        console.log('✅ Auth emulator connected')
        // }

        connectFirestoreEmulator(db, 'localhost', 8080)
        console.log('✅ Firestore emulator connected')

        connectStorageEmulator(storage, 'localhost', 9199)
        console.log('✅ Storage emulator connected')

        connectFunctionsEmulator(functions, 'localhost', 5001)
        console.log('✅ Functions emulator connected')

        emulatorsConnected = true
    } catch (error) {
        console.log('💡 Firebase emulators not available - using production Firebase')
    }
}

export default app
